import { Component, Input } from '@angular/core';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { TimeRange, Sponsor } from 'src/app/catalogs/catalogs.model';
import { PROMOTION_TYPES } from 'src/app/constants/promotions.constants';
import { copyToClipboard } from '../../helpers/helpers';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import html2canvas from 'html2canvas';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-promotion-modal',
  templateUrl: './promotion-modal.page.html',
  styleUrls: ['./promotion-modal.page.scss']
})
export class PromotionModalPage {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() name: string;
  @Input() description: string;
  @Input() code: string;
  @Input() timeRange: TimeRange;
  @Input() loyaltyCardRelation = false;
  @Input() type: string;
  @Input() phone: string;
  @Input() sponsor: Sponsor;
  @Input() banner: string;
  @Input() shared = false;

  PROMOTION_TYPES = PROMOTION_TYPES;
  promotionContentId: string;

  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
    private socialSharing: SocialSharing,
    private toastCtrl: ToastController,
    private translocoService: TranslocoService
  ) {
    this.promotionContentId = `promotion-content-${this.code}`;
  }

  getDescription(timeRange: TimeRange) {
    if (!timeRange) {
      return this.translocoService.translate('promotion.redeemMessage');
    } else {
      return this.translocoService.translate('promotion.redeemTimeRangeMessage', {from: this.parseDate(timeRange.from), to: this.parseDate(timeRange.to)});
    }
  }

  getBottomCaption() {
    return this.loyaltyCardRelation
      ? this.translocoService.translate('promotion.loyaltyCardRelationMessage', {title: this.title})
      : this.translocoService.translate('promotion.enjoy');
  }

  parseDate(timestamp: string) {
    const date = new Date(timestamp);
    const minutes = date.getUTCMinutes();
    const hours = date.getHours();
    return `${hours < 10 ? '0' + hours : hours}:${
      minutes < 10 ? '0' + minutes : minutes
    }`;
  }

  handleCall() {
    if (this.platform.is('capacitor') || this.platform.is('cordova')) {
      window.open('tel:' + this.phone, '_system');
    } else {
      window.open('tel:' + this.phone, '_self');
    }
  }

  onClose() {
    this.modalCtrl.dismiss();
  }

  async handleSharedPromotion() {
    const content = document.getElementById(this.promotionContentId);
    const canvas = await html2canvas(content);
    if (this.platform.is('cordova') || this.platform.is('capacitor')) {
      await this.socialSharing.share(
        null,
        null,
        canvas.toDataURL('image/png')
      );
    } else {
      copyToClipboard(canvas.toDataURL('image/png'));
      const toast = await this.toastCtrl.create({
        message: this.translocoService.translate('common.copyLink'),
        duration: 2000
      });
      await toast.present();
    }
    return this.onClose();
  }
}
